const style = {
  flex: "1 1 0",
  outline: "solid 1px #C0C0C0",
  borderTopRightRadius: 12
};

export function BroadcastSelectorContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
